import { useEffect } from "react";
import { useDispatch , useSelector } from "react-redux";
 
import { GetItemType } from "../../store/Lookup/lookupSlice";

const useLookupGetItemType = ()=>{

    const dispatch = useDispatch();
    
    useEffect(()=>{
        dispatch(GetItemType())
      },[])

    const {  ITEM_TYPE , loading , error} = useSelector((state) => state.Lookup); 

    return { ITEM_TYPE , loading , error} ;
};

export default useLookupGetItemType ;